// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"950":"d39f9b39","9291":"3dd3b9f4"}[chunkId] + ".chunk.css";
};